const KEY = "CROW_USAGE_API_KEY";

export function getToken(): string | null {
  return window.sessionStorage.getItem(KEY);
}

export function setToken(token: string): void {
  window.sessionStorage.setItem(KEY, token);
}

export function clearToken(): void {
  window.sessionStorage.removeItem(KEY);
}

export const UNAUTHORIZED_EVENT = "crow-usage:unauthorized";
